module.exports = __webpack_public_path__ + "static/media/1274_CareTeam_bio1.4ae52339.png";